package com.daytimegaming.ourdailyfinances.domain.event

import com.daytimegaming.ourdailyfinances.domain.account.AccountEventBus
import com.daytimegaming.ourdailyfinances.domain.dashboard.DashboardEventBus
import com.daytimegaming.ourdailyfinances.domain.repository.AuthRepository
import com.daytimegaming.ourdailyfinances.domain.repository.EventRepository
import com.daytimegaming.ourdailyfinances.getPlatform
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.launch

class RealtimeEventStreamManager(
    private val authRepository: AuthRepository,
    private val eventRepository: EventRepository,
    private val dashboardEventBus: DashboardEventBus,
    private val accountEventBus: AccountEventBus,
) {
    private val scope = CoroutineScope(SupervisorJob() + Dispatchers.Default)
    private var streamJob: Job? = null

    init {
        start()
    }

    fun start() {
        val platformName = getPlatform().name
        val isWebOrDesktop = platformName == "Web Browser" || platformName.startsWith("Java")
        if (!isWebOrDesktop) return

        scope.launch {
            authRepository.currentUser().collect { user ->
                if (user != null) {
                    if (streamJob == null || streamJob?.isActive != true) {
                        streamJob = scope.launch {
                            eventRepository.getServerEvents().collect { event ->
                                when (event.type) {
                                    "dashboard_changed" -> dashboardEventBus.tryEmitDashboardChanged(event.dashboardId)
                                    "account_changed" -> accountEventBus.tryEmitAccountChanged(event.accountId)
                                }
                            }
                        }
                    }
                } else {
                    streamJob?.cancel()
                    streamJob = null
                }
            }
        }
    }
}
